import { api } from "../api";

export async function getSearchFieldsExtra() {
  return await api.get("ParametresReservationEnLigne/Animaux");
}
